<template>
  <WfRow
    :selectable="true"
    :expandable="hasMultipleModes"
    :status="status"
    :is-open="isOpen"
    :level="level"
    @check="handleCheck"
    @open="isOpen = $event"
  >
    <template #title>
      <div :class="$style.labelWrapper">
        <span :class="[$style.label, $style.variableLabel]">
          <WfIcon :icon="icon" />
          {{ variable.name }}
        </span>
        <WfVariableValue v-if="!hasMultipleModes" :variable="variable" :mode="variable.modes[0]" />
      </div>
    </template>
    <template #content v-if="hasMultipleModes">
      <WfRow
        v-for="variableMode in variable.modes"
        :key="variableMode.compositeId"
        :level="level + 1"
      >
        <template #title>
          <div :class="[$style.labelWrapper, $style.modeWrapper]">
            <div :class="$style.label">
              <WfIcon :icon="icon" />
              {{ getMode(variableMode.compositeId).name }}
            </div>
            <WfVariableValue :variable="variable" :mode="variableMode" />
          </div>
        </template>
      </WfRow>
    </template>
  </WfRow>
</template>

<style lang="scss" module>
.modeWrapper {
  padding-left: 5px;
}

.labelWrapper {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.label {
  display: flex;
  align-items: center;
  gap: 8px;

  :global(svg) {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    padding: 2px;
  }
}

.variableLabel {
  font-weight: v-bind(labelWeight);
}
</style>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import WfRow from './row/WfRow.vue';
import WfIcon from '@/components/WfIcon.vue';
import WfVariableValue from './variable/WfVariableValue.vue';

const props = defineProps({
  variable: {
    type: Object,
    required: true,
  },
  level: {
    type: Number,
    default: 0,
  },
});

const store = useStore();

const labelWeight = computed(() => {
  return props.variable.modes.length > 1 ? 'bold' : 'normal';
});

const status = computed(() => {
  return store.getters['variable/isVariableSelected'](props.variable.id)
    ? 'selected'
    : 'unselected';
});

const hasMultipleModes = computed(() => {
  return props.variable.modes.length > 1;
});

const icon = computed(() => {
  const type = props.variable.type;
  return type === 'COLOR' ? 'color-swatch' : type === 'LENGTH' ? 'length-variable' : 'typography';
});

const isOpen = ref(false);

const getMode = (modeId) => {
  return store.getters['variable/modeMap'].get(modeId).mode;
};

const handleCheck = () => {
  store.dispatch('variable/toggleVariable', props.variable.id);
};
</script>
